
    import Vue from 'vue'
    import router from "../../router";
    import ReziseSensor from "css-element-queries/src/ResizeSensor";
    import VuePlotly from '@statnett/vue-plotly'
    import { home } from '../../config/home'


    export default Vue.extend({
        name: 'David',
        metaInfo: {
            title: 'QDRA',
            meta : [
                {
                    name: 'description',
                    content : 'Thunderstorms and Cyclones are a part of life in Australia. The Queensland Disaster Research Alliance (QDRA) is a state-based University collaboration that aims to grow and integrate Queensland’s capability and capacity to deliver high impact and at-scale disaster management research outcomes for the state, nationally and internationally.'
                },
                {
                    name: 'keywords',
                    content : 'cyclones, thunderstorms, disasters, floods, fires, Australia, Queensland, houses, storm preparation, cyclone, weather, storm, protection, collaboration, disaster management, research, education'
                }
            ]
        },
        components: {
        },

        data: () => ({

            "frames": [],
            "home" : home,
            options: {
                "autoresize": true,
                "autosize": true,
                "autosizable": true,
                "reponsive": true
            },
            autoresize: true,

        }),
        methods: {
            gotoSelect() {
                router.push('/select').catch(err => {
                    return err
                })
            },
            gotoHome() {
                router.push('/').catch(err => {
                    return err
                })
            },
            gotoWind() {
                router.push('/wind').catch(err => {
                    return err
                })
            },
            gotoResources() {
                router.push('/resources').catch(err => {
                    return err
                })

            }
        },
        computed: {
            minHeight () {
                const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '100vh'

                return `calc(${height} - ${this.$vuetify.application.top}px)`
            },
        }

    })
